import {IEvent, ILinkListAd} from "@webng-types/write-model";
import {AbstractAdManager} from "./AbstractAdManager";
import {
  EventExtension,
  // isRelativeUrl,
  // updateOEmbed,
  // UpdateOEmbedResult,
  // useRelativeLinkBaseUrl
} from "@webng/liveblog/src";
import React, {ReactNode} from "react";
// import {OEmbed} from "@webng/liveblog/src/webembed/OEmbed";
// import {useAuthenticatedApi} from "@webng/react-app-common";
// import { LinkListItem } from "./LinkListItem";
import { LinkListAd } from "@webng/liveblog/src/ads/LinkList";


// function LinkListAdItem({link, oembed} : {link :string, oembed: OEmbed|undefined}) {
//   const [json, setJson] = useState<OEmbed|undefined>(oembed)
//   const apiClient = useAuthenticatedApi();
//   const relativeLinkBaseUrl = useRelativeLinkBaseUrl();

//   const baseUrl = relativeLinkBaseUrl || ((typeof window !== "undefined") && window.location && window.location.origin);
//   const url = baseUrl && isRelativeUrl(link) ? new URL(link, baseUrl).toString() : link

//   const onOEmbedUpdated = useCallback((result: UpdateOEmbedResult) => {
//     if(url === result.requestedUrl) {
//       if(result.oembed) {
//         setJson(result.oembed)
//       }
//     }
//   }, [url, setJson])

//   useEffect(() => {
//     if(!json || url !== json._original) {
//       const promise = updateOEmbed(apiClient, url, onOEmbedUpdated)
//       return () => promise.cancel()
//     }
//   }, [json, apiClient, url, onOEmbedUpdated])

//   if(json) {
//     return <LinkListItem oembed={json} />
//   } else {
//     return <React.Fragment />
//   }
// }


// function LinkListAd({linkListAd}: { linkListAd: ILinkListAd }) {
//   const {t} = useTranslation("liveblog");
  
//   return <div className="tik4-link-list">
//     <div className={`tik4-link-list__header ${linkListAd.links.length === 1 ? "tik4-link-list__header--one" : ""}`} role="heading" aria-level={3}>
//       {/* TODO:Timo! titel ausgeben sobald vorhanden */}
//       <span className="tik4-link-list__header-content">{t("liveblog.link_list.title", { count: linkListAd.links.length })}</span>
//     </div>
//     <div className="tik4-link-list__list" role="list">
//       {linkListAd.links.map((link, i) => {
//         try {
//           const oembed = JSON.parse(link) as OEmbed;
//           return <div className="tik4-link-list__list-item" role="listitem" key={i}><LinkListAdItem link={oembed._original} oembed={oembed} /></div>
//         } catch (e) {
//           return <div className="tik4-link-list__list-item" role="listitem" key={i}><LinkListAdItem link={link} oembed={undefined} /></div>
//         }
//       })}
//     </div>
//   </div>
// }

export class LinkListAdManager extends AbstractAdManager {
  private _linkListAd: ILinkListAd;
  private _node: ReactNode

  constructor(position: keyof EventExtension, linkListAd: ILinkListAd) {
    super(position);
    this._linkListAd = linkListAd;
    this._node = <LinkListAd linkListAd={linkListAd} />
  }

  update(rows: IEvent[]) {
    // Only show the link list at the specified index
    const index = this._linkListAd.index;

    rows.forEach((row, rowIndex) => {
      if(index === rowIndex) {
        this.notify(row, this._node);
      } else {
        this.notify(row, undefined);
      }
    })
  }
}
